<template>
    <Card class="card" @submitted="saveModel">
        <template #title>
            Налаштування AI
        </template>

        <template #content>

            <!-- Name -->
            <div class="field">
                <label for="name"><b>AI API KEY</b></label>
                <input class="form-control" type="text" v-model="model.key" />
            </div>
            <div class="field">
                <label for="name"><b>Model variant</b></label>
                <select class="form-control" v-model="model.model">
                    <option :value="null" disabled>AI модель</option>
                    <option value="gemini-2.5-pro-preview-03-25">Gemini 2.5 Pro Preview 03-25</option>
                    <option value="gemini-2.0-flash">Gemini 2.0 Flash</option>
                    <option value="gemini-1.5-flash">Gemini 1.5 Flash</option>
                    <option value="gemini-1.5-flash-8b">Gemini 1.5 Flash-8B</option>
                    <option value="gemini-1.5-pro">Gemini 1.5 Pro</option>
                </select>
            </div>
            <div class="field">
                <label for="name"><b>Promt description</b></label>
                <textarea rows="10" cols="90" class="form-control" v-model="model.promt"></textarea>
            </div>
            <div class="field">
                <label for="name"><b>Promt характеристики</b></label>
                <textarea rows="10" cols="90" class="form-control" v-model="model.promt_characteristics"></textarea>
            </div>
            <div class="field">
                <label for="name"><b>Promt аналогів</b></label>
                <textarea rows="10" cols="90" class="form-control" v-model="model.promt_analogs"></textarea>
            </div>
            <div class="checkbox field">
                <label for="name"><b>Зберігати аналоги ринку</b></label>
                <Checkbox v-model="model.save_analogs" :binary="true" />
            </div>
        </template>

        <template #footer>
            <Button
                label="Зберегти"
                @click="saveModel"
            />
        </template>
    </Card>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import Card from "primevue/card";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import FlashMessage from "../../Services/FlashMessage";
import Checkbox from 'primevue/checkbox';
import Toast from 'primevue/toast';
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css"

export default {
    layout: AppLayout,
    components: {
        Card,
        InputText,
        Button,
        Checkbox,
        "p-toast": Toast,
    },

    props: ['data'],
    mixins: [FlashMessage],
    data() {
        return {
            model: {
                key: this.data.key,
                model: this.data.model,
                promt: this.data.promt,
                promt_characteristics: this.data.promt_characteristics,
                promt_analogs: this.data.promt_analogs,
                promt_analogs_result: this.data.promt_analogs_result,
                save_analogs: this.data.save_analogs,
            },
        }
    },

    methods: {
        saveModel() {
            if (this.model) {
                axios.post(this.route('api.analogs.settings.save'), {settings: this.model})
                    .then((result) => {
                        this.$toast.add({severity: 'info', summary: 'Збережено', detail: '', life: 3000});
                    }).catch((error) => {
                        console.log(error);
                    })
            }
        }
    },
}
</script>

<style scoped>
.checkbox.field {
    display: flex;
    flex-direction: column;
}
</style>